var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9226 12.2695C9.74791 11.104 8.66893 10.0167 7.57254 8.93807C7.26799 8.63362 7.12006 8.29439 7.24189 7.87687C7.44202 7.15491 8.31217 6.96355 8.87777 7.52894C9.87844 8.51185 10.8704 9.51216 11.8624 10.5125C11.9755 10.6255 12.0625 10.756 12.2017 10.9387C12.8108 10.3124 13.3677 9.74701 13.9246 9.18162C14.4119 8.68582 14.9079 8.19871 15.4039 7.7029C15.9869 7.12012 16.5525 7.05053 16.9875 7.49414C17.4226 7.93776 17.3443 8.49445 16.7526 9.07724C15.839 9.99057 14.934 10.9039 14.0116 11.8085C13.8811 11.939 13.7071 12.026 13.4809 12.1825C13.9768 12.6523 14.3771 13.0176 14.7513 13.3916C15.4126 14.044 16.0652 14.7051 16.7178 15.3574C17.3443 15.9837 17.4313 16.5143 16.9875 16.9666C16.5351 17.4276 15.9956 17.3494 15.3778 16.7231C14.3423 15.688 13.3155 14.6529 12.1408 13.4699C12.0277 13.6613 11.9581 13.8526 11.8276 13.9831C10.8617 14.966 9.88714 15.9402 8.91257 16.9057C8.53841 17.2798 8.12944 17.3494 7.72917 17.1493C7.355 16.9579 7.12877 16.5578 7.23318 16.1403C7.29409 15.9054 7.45072 15.6706 7.62475 15.4879C8.57321 14.5137 9.54778 13.5569 10.5136 12.5914C10.6181 12.4783 10.7573 12.3913 10.9226 12.2695Z",
    fill: "url(#paint0_linear_992_7942)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0163 2.42448e-06C18.6361 0.00416952 24.0042 5.38639 24 12.0163C23.9958 18.6361 18.6136 24.0042 11.9837 24C5.36389 23.9967 -0.00416468 18.6136 2.42448e-06 11.9837C0.00416952 5.36389 5.38639 -0.00416468 12.0163 2.42448e-06ZM12.0238 1.08762C6.01813 1.07511 1.11012 5.95229 1.08762 11.9554C1.06511 17.9794 5.95479 22.9007 11.9762 22.9124C17.9827 22.9249 22.8899 18.0477 22.9124 12.0446C22.9349 6.02063 18.0452 1.09928 12.0238 1.08762Z",
    fill: "url(#paint1_linear_992_7942)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_992_7942",
    x1: 12.2322,
    y1: 7.19922,
    x2: 12.2322,
    y2: 17.2615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_992_7942",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.5440d286a241e595f55c20cf632f50bb.svg";
export { ForwardRef as ReactComponent };